import {AntibodyEnforcedSchemaRole} from 'antibodies/schema-configuration/AntibodyEnforcedDataModelConstants';
import {FieldMigrationMapping} from 'antibodies/schema-configuration/schema-migration/AntibodySchemaMigrationConstants';
import {NamingStrategy} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as net from 'util/Net';

export interface BeginMigrateSchemaInput {
  schemaId: string;
  antibodyRole: AntibodyEnforcedSchemaRole;
  preferredNamingStrategies?: Array<NamingStrategy>;
  fieldMigrationMappings?: Array<FieldMigrationMapping>;
}

export interface BeginMigrateSchemaResponse {
  schemaId: string;
  antibodyRole: AntibodyEnforcedSchemaRole;
  asyncMigrationPending: boolean;
}

export function beginMigrateSchema(input: BeginMigrateSchemaInput): Promise<BeginMigrateSchemaResponse> {
  return net.postJSONPromise({
    url: '/1/api/proteins/schema-migration/begin-migration',
    data: input,
  });
}

export interface FinalizeMigrateSchemaInput {
  schemaId: string;
  antibodyRole: AntibodyEnforcedSchemaRole;
}

export interface FinalizeMigrateSchemaResponse {
  schemaId: string;
}

export function finalizeMigrateSchema(
  input: FinalizeMigrateSchemaInput
): Promise<FinalizeMigrateSchemaResponse> {
  return net.postJSONPromise({
    url: '/1/api/proteins/schema-migration/publish-migration',
    data: input,
  });
}

export interface RollbackMigrateSchemaInput {
  schemaId: string;
}

export interface RollbackMigrateSchemaResponse {
  schemaId: string;
}

export function rollbackMigrateSchema(
  input: RollbackMigrateSchemaInput
): Promise<RollbackMigrateSchemaResponse> {
  return net.postJSONPromise({
    url: '/1/api/proteins/schema-migration/rollback-migration',
    data: input,
  });
}
